import { departmentKeys, colorVariants } from "../lib/colors";
import { Instructors } from "./instructors";
import { Category } from "./category";

const CardItem = ({ subject, SYLLABUS_BASE_URL }) => {
    const departmentKey = departmentKeys[subject.department];
    const styles = colorVariants[departmentKey];
    const category = subject.subject_category + " / " + subject.registration_category;

    return (
        <div className={`bg-white dark:bg-zinc-800 flex flex-col justify-between p-4 rounded-xl shadow-md border-l-4 ${styles.cardBorder}`}>
            <div className="mb-3">
                <div className="flex justify-between items-start mb-3 sm:flex-col sm:mb-0 md:flex-row md:mb-3">
                    <h3 className="text-lg font-bold text-gray-800 dark:text-white">{subject.subject_name}</h3>
                    <span className={`px-2 py-1 my-auto sm:my-2 md:my-auto text-xs font-semibold rounded-full ${styles.badge} whitespace-nowrap`}>
                        {subject.department}
                    </span>
                </div>
                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">学年・開設時期</p>
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">{subject.grade}年・{subject.semester}</p>
                </div>
                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">科目区分</p>
                    <span className="text-sm font-semibold text-gray-600 dark:text-slate-200"><Category category={category} classification={subject.classification} /></span>
                </div>
                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">単位種別/単位数</p>
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">{subject.credit_type}: {subject.credits}単位</p>
                </div>
                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">担当教員</p>
                    <span className="text-sm font-semibold text-gray-600 dark:text-slate-200"><Instructors instructors={subject.instructors} /></span>
                </div>
                <div className="flex justify-between items-center py-2 border-t border-gray-300">
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">授業形態</p>
                    <p className="text-sm font-semibold text-gray-600 dark:text-slate-200">{subject.class_format}</p>
                </div>
            </div>
            {subject.syllabus_url ? (
                <a 
                    href={`${SYLLABUS_BASE_URL}${subject.syllabus_url}`} target="_blank" rel="noopener noreferrer"
                    className={`flex justify-center py-1.5 border rounded-lg duration-250 ease-linear text-sm ${styles.button} ${styles.focus}`}
                >
                    詳細を見る &rarr;
                </a>
            ) : (
                subject.subject_name
            )}
        </div>
    );
};

export const Cards = ({ subjects, SYLLABUS_BASE_URL }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
            {subjects.map((subject) => 
                <CardItem key={subject.subject_id} subject={subject} SYLLABUS_BASE_URL={SYLLABUS_BASE_URL} />
            )}
        </div>
    );
};